// 공지사항 데이터 구조 정의
export const defaultZoomNotification = {
  admin_id: "",
  created_at: new Date(),
  discription: "",
  image_url: "",
  is_show: true,
  title: "",
};

// 개별 공지사항 유효성 검사 함수
export const validateZoomNotification = (data) => {
  if (!data) return false;

  const requiredFields = [
    "admin_id",
    "created_at",
    "discription",
    "image_url",
    "is_show",
    "title",
  ];

  // 필수 필드 존재 여부 확인
  for (const field of requiredFields) {
    if (data[field] === undefined || data[field] === null) {
      return false;
    }
  }

  // 타입 검사
  if (typeof data.title !== "string") {
    return false;
  }

  if (typeof data.discription !== "string") {
    return false;
  }

  if (typeof data.is_show !== "boolean") {
    return false;
  }

  return true;
};

// 공지사항 배열 유효성 검사 함수
export const validateZoomNotificationArray = (data) => {
  if (!Array.isArray(data)) {
    return false;
  }

  for (const item of data) {
    if (!validateZoomNotification(item)) {
      return false;
    }
  }

  return true;
};
